import { render, staticRenderFns } from "./VaTimelineItem.demo.vue?vue&type=template&id=20b43569&"
import script from "./VaTimelineItem.demo.vue?vue&type=script&lang=js&"
export * from "./VaTimelineItem.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports